module.exports = __webpack_public_path__ + "static/media/image-10.82fbf94a.avif";